import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import React from 'react'
import { CMSState } from '../../../../cms/blocks/types.gen'
import { getClassName } from '../../../../cms/blocks/utils.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { gtmPush } from '../../../../../helpers'
import { PublicSiteState } from '../../../../public_site.main.mod'

export type DownloadItemBlockProps = {
  key: string
  title: string
  url: string
  file_name: string

  show_in_page_navigation: boolean
  navigation_title: string
}

export type DownloadItemBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  intro_classname: string
  content_classname: string
  list_classname: string
  item_classname: string
  link_classname: string
}>

export function DownloadItemBlock<customBlockData, extra_images>(
  props: DownloadItemBlockProps,
  options?: { style?: DownloadItemBlockStyle }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) =>
    mk_widget({
      run: _ => (
        <ul
          id={props.navigation_title}
          className={getClassName(options, 'list_classname', 'list-unstyled row mb-0')}>
          <li className={getClassName(options, 'item_classname', 'col-md-6')} key={props.key ? props.key : props.url}>
            <a
              download={true}
              target="_blank"
              href={props.url}
              className={getClassName(
                options,
                'link_classname',
                'btn btn-link w-100 text-left border-bottom rounded-0 pl-0'
              )}
              onClick={() =>
                gtmPush({
                  category: "Downloads",
                  action: props.title
                })}
            >
              {props.title}
            </a>
          </li>
        </ul>
      )
    })
}



// WEBPACK FOOTER //
// ./Client/components/public_site/blocks/custom_blocks/widgets/downloadItemBlock.tsx